import React from 'react'
import CalendarContent from './CalendarContent'
import LinesEllipsis from 'react-lines-ellipsis'

class CalendarComponent extends React.Component {
  render () {
    return (
      <div>
        <div style={styles.paper}>
          <div style={styles.contentTitle}>
            <LinesEllipsis
              style={styles.title}
              text='CHOISISSEZ UNE DATE'
              maxLine='1'
              ellipsis='...'
              trimRight
              basedOn='letters'
            />
          </div>
          <div style={styles.content}>
            <CalendarContent
              initialMonth={this.props.initialMonth}
              onMonthChange={this.props.onMonthChange}
              selectedDay={this.props.selectedDay}
              dateList={this.props.dateList}
              handleDayClick={this.props.handleDayClick}
            />
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  paper: {
    textAlign: 'center',
    backgroundColor: '#364248',
    height: '334px',
    paddingTop: '12px',
    marginTop: '60px',
    overflowY: 'hidden',
    overflowX: 'auto',
    borderRadius: '3px',
    minWidth: '280px'
  },
  contentTitle: {
    textAlign: 'center',
    width: '100%',
    height: '20px'
  },
  title: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#FFFFFF'
  },
  content: {
    textAlign: 'center',
    width: '100%',
    height: '300px',
    marginTop: '20px'
  }
}

export default CalendarComponent
